export const ORDER_DETAIL = [
    {
        value: -1,
        name: 'Цуцлагдсан'
    },
    {
        value: 1,
        name: 'Төлбөр хүлээгдэж байна'
    },
    {
        value: 2,
        name: 'Бэлтгэгдэж байна'
    },
    {
        value: 3,
        name: 'Замд гарсан'
    },
    {
        value: 4,
        name: 'Хүргэгдсэн'
    },
]